import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import './home.scss';
import '../components/business-info.scss';
import Slideshow from "../components/slideshow";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faMapLocationDot, faWrench, faCarBattery, faDotCircle } from "@fortawesome/free-solid-svg-icons";

import VideoPlayer from '../components/videoplayer';

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Auto Repair &amp; Tires in Waynesboro &amp; Staunton | GOLDWrench</title>
                <meta name="description" content="Auto repair and tires in Waynesboro and Staunton, VA. GOLDWrench offers batteries, alternators, starters, brakes, tire repairs, balancing and wheel alignment." />
            </Helmet>

            <header className="home-introduction">
                <p className="home-location-line">Waynesboro &amp; Staunton, Virginia</p>
                <h1>GOLDWrench Automotive</h1>
                <p>From routine maintenance to repairs, we’re here to help keep your vehicle on the road. Choose your location for hours, directions and appointments.</p>
            </header>
            <section className="home-services" aria-label="Explore our auto repair and tire services">
                <article className="home-service-card">
                    <span className="home-service-icon" aria-hidden="true"><FontAwesomeIcon icon={faWrench} /></span>
                    <h2>Repairs &amp; maintenance</h2>
                    <p>Brake repair, oil changes, engine diagnostics, cooling systems, steering and suspension.</p>
                    <Link to="/autorepairs">Explore auto repair <span aria-hidden="true">→</span></Link>
                </article>
                <article className="home-service-card">
                    <span className="home-service-icon" aria-hidden="true"><FontAwesomeIcon icon={faCarBattery} /></span>
                    <h2>Batteries &amp; starting</h2>
                    <p>Battery testing and replacement, plus alternator and starter diagnostics and replacement.</p>
                    <Link to="/autorepairs">Battery &amp; electrical services <span aria-hidden="true">→</span></Link>
                </article>
                <article className="home-service-card">
                    <span className="home-service-icon" aria-hidden="true"><FontAwesomeIcon icon={faDotCircle} /></span>
                    <h2>Tires &amp; alignment</h2>
                    <p>Tire installation, flat tire repairs, rotation, wheel balancing and wheel alignment.</p>
                    <Link to="/tires">Explore tire services <span aria-hidden="true">→</span></Link>
                </article>
            </section>
            <div className="business-info" style={{ paddingTop: 0 }}>
                <h2>
                    <Link to="/about" className="vision-link">
                        <FontAwesomeIcon icon={faEye} /> Discover Our Vision
                    </Link>
                </h2>
                <p className="video-description">
                    Dive into our journey – watch this short video to understand our mission and what drives us.
                </p>
                <VideoPlayer />
            </div>
            <div className="Home">
                <h2><FontAwesomeIcon icon={faMapLocationDot} /> Explore Our Latest Projects</h2>
                <p className="slideshow-description">
                    Take a visual tour through our recent projects. See the transformations and our team in action.
                </p>
                <Slideshow></Slideshow>
            </div>
        </>
    );
};

export default Home;
